import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { LeaderboardEntry } from '../types/leaderboard';
import type { User } from '../types/user';

interface LeaderboardStore {
  entries: LeaderboardEntry[];
  updateUserPoints: (walletAddress: string, points: number) => void;
  addUser: (user: User) => void;
}

export const useLeaderboardStore = create<LeaderboardStore>()(
  persist(
    (set) => ({
      entries: [],
      
      updateUserPoints: (walletAddress: string, points: number) => {
        set((state) => {
          const newEntries = state.entries.map(entry => {
            if (entry.walletAddress === walletAddress) {
              return {
                ...entry,
                points,
                lastUpdated: new Date().toISOString()
              };
            }
            return entry;
          });

          return {
            entries: sortAndUpdateRanks(newEntries)
          };
        });
      },

      addUser: (user: User) => {
        set((state) => {
          // Check if user already exists
          const existingUser = state.entries.find(
            entry => entry.walletAddress === user.walletAddress
          );

          if (existingUser) {
            return state;
          }

          // Create new entry
          const newEntry: LeaderboardEntry = {
            username: user.username,
            walletAddress: user.walletAddress,
            points: user.points,
            rank: 1,
            lastUpdated: new Date().toISOString()
          };

          const newEntries = [...state.entries, newEntry];
          return {
            entries: sortAndUpdateRanks(newEntries)
          };
        });
      }
    }),
    {
      name: 'kingdom-leaderboard',
      storage: createJSONStorage(() => localStorage),
      version: 1
    }
  )
);

function sortAndUpdateRanks(entries: LeaderboardEntry[]): LeaderboardEntry[] {
  return entries
    .sort((a, b) => b.points - a.points)
    .map((entry, index) => ({
      ...entry,
      previousRank: entry.rank,
      rank: index + 1
    }));
}